import moment from 'moment'

export default {
  search(VueApp, callback) {
    let self = this
    let search = VueApp.$store.state.searchGlobal
    let request = {
      token: VueApp.$store.state.session.sessionToken,
      search: search.searchInput,
      pageNum: search.currentPage,
      pageSize: search.perPage,
      order: 'pickupTime',
      orderAsc: 0
    }
    VueApp.$sdk.get('/reservation', request, r => {
      if (!r.error) {
        VueApp.$store.commit('searchGlobal/setSearchGlobalMaxList', r.paging.totalItems)
        for (let i = 0; i < r.list.length; i++) {
          VueApp.$store.commit('searchGlobal/addSearchGlobalList', self.formatSearchResult(r.list[i]))
        }
      }
      callback(r)
    }, '2.0')
  },
  formatSearchResult(item) {
    return {
      rsvpID: item.ID,
      dropoffLocation: item.dropoffLocation.title,
      pickupLocation: item.pickupLocation.title,
      total: parseFloat(item.total).toFixed(2),
      pickupDate: moment(item.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY'),
      pickupTime: moment(item.pickupDate, 'YYYY-MM-DD HH:mm').format('h:mm A'),
      status: item.dispatchStatus,
      customerName: item.consumer.firstName + ' ' + item.consumer.lastName,
      customerID: item.consumer.ID,
      customerEmail: item.consumer.email
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/search-global/index.js